import { AccessRoleBuilder } from '@gluai-studio/passport';

// name of modules must be SINGULAR
// add modules in PERMISSION_MATRIX and Permissions interface in this file to configure permissions
// in PERMISSION_MATRIX, the key is the module name and the value is an array permissions, by default CRUD permissions are added
// if any additional permissions are needed, add them to the array

export const PERMISSION_MATRIX = {
  user: [],
  role: [],
  media: [],
  trail: [],
  country: [],
  tenant: [],
  job: [],
  visaApplication: [],
  emailConfiguration: [],
  workflow: [],
  bot: [],
  status: [],
};

export type Permissions = {
  [resourceName: string]: {
    [action: string]: boolean;
  };
};

export const rbac = new AccessRoleBuilder();
